import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { listPartnerPlanPayments } from '../services/partnerPlans';
import { partnerPlanPaymentsQueryKeys } from './query-keys';
import { PARTNER_PLAN_PAYMENTS_PAGE_SIZE } from '../utils/partnerSubscriptionPayments';

export const usePartnerPlansPaymentsQuery = (
  { page = 1, limit = PARTNER_PLAN_PAYMENTS_PAGE_SIZE } = {},
  options = {},
) => {
  const { isPartner } = useAuth();
  const { enabled = true, ...rest } = options;
  const params = {
    page: Math.max(1, Number(page) || 1),
    limit: Math.max(1, Number(limit) || PARTNER_PLAN_PAYMENTS_PAGE_SIZE),
  };

  return useQuery({
    queryKey: partnerPlanPaymentsQueryKeys.list(params),
    enabled: isPartner && enabled,
    queryFn: async () => {
      const result = await listPartnerPlanPayments(params);
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch partner subscription payments');
      }
      return result.data;
    },
    ...rest,
  });
};
